import { WarningTwoIcon } from "@chakra-ui/icons";
import { Flex, Spinner, Stat, StatLabel, StatNumber, Text, useColorModeValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import moneyFormat from "helpers/moneyFormat";
import { Box } from "@mui/material";

const DataLabel = ({
    url,
    filters,
    label,
    isMoney = true,
    countDateColumn = null,
    countDayColumn = null,
    columns = [],
    filtersReady = true,
    updateCount = 0,
    explanationText = null // Nueva propiedad para texto explicativo
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [result, setResult] = useState();
    const [displayText, setDisplayText] = useState(explanationText); // Estado para texto explicativo
    const textColor = useColorModeValue("white", "white");
    
    // Efecto para determinar el texto explicativo basado en filtros
    useEffect(() => {
        let text = explanationText;
        
        // Buscar filtros con prefijo "periodo_"
        if (filters && filters.length > 0) {
            const periodoFilter = filters.find(filter => 
                filter.id && filter.id.startsWith('periodo_') && filter.value
            );
            
            if (periodoFilter && periodoFilter.value) {
                // Formato del periodo: de "YYYY-MM" a "MM/YYYY"
                const periodoValue = periodoFilter.value;
                if (typeof periodoValue === 'string' && periodoValue.includes('-')) {
                    const [year, month] = periodoValue.split('-');
                    text = `${month.padStart(2, '0')}/${year}`;
                }
            } else {
                // Si no hay periodo, mostrar "12 meses"
                if (!text) text = "12 meses";
            }
        } else {
            // Si no hay filtros, mostrar "12 meses"
            if (!text) text = "12 meses";
        }
        
        setDisplayText(text);
    }, [filters, explanationText]);
    
    useEffect(() => {
        const fetchData = async () => {
            if (!result) {
                setIsLoading(true);
            }
            // Caso especial: si tenemos tanto periodo como día específico
            if (countDateColumn && countDayColumn) {
                const periodoFilter = filters.find(i => i.id === countDateColumn);
                const diaFilter = filters.find(i => i.id === countDayColumn);
                
                // Si ambos filtros están presentes, mostramos "1" (un día específico)
                if (periodoFilter && periodoFilter.value && diaFilter && diaFilter.value) {
                    setResult(1);
                    setIsLoading(false);
                    return;
                }
            }
            if (countDateColumn) {
                if (countDateColumn.includes('periodo')) {
                    const periodo = filters.find(i => i.id == countDateColumn);
                    if (!periodo) {
                        setIsError(true);
                        return;
                    }
                    const [year, month] = periodo.value.split('-').map(Number);
                    const daysInMonth = new Date(year, month, 0).getDate();
                    setResult(daysInMonth);
                    setIsLoading(false);
                    return;
                }
                const fechas = filters.find(i => i.id == countDateColumn);
                if(!fechas || fechas.value.length != 2)
                {
                    setIsError(true);
                    return;
                }
                const diff = fechas.value[1].diff(fechas.value[0],'day',true);
                setResult(Math.floor(diff)-1);
                setIsLoading(false);
                return;
            }
            try {
                let currentFilters = [...filters];
                currentFilters = currentFilters.filter(filter => 
                    Object.keys(columns).some(columnKey => columnKey === filter.id)
                );
                const response = await fetch(url + '&' + new URLSearchParams({
                    filters: JSON.stringify(currentFilters ?? [])
                }),
                    {
                        method: "post",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": localStorage.getItem('token'),
                        }
                    });
                const json = await response.json();
                setResult(json.data[0].total || 0);
            } catch (error) {
                setIsError(true);
                console.error(error);
                return;
            }
            setIsError(false);
            setIsLoading(false);
        };
        fetchData();
    }, [
        filters, updateCount, url, columns, countDateColumn, countDayColumn, filtersReady
    ]);
    
    return <Flex align='center' mb='9px'>
        {isError ?
            <WarningTwoIcon w={8} h={8} color="blue.500" /> :
            <Stat me='auto'>
                <StatLabel
                    fontSize='xs'
                    color='gray.400'
                    fontWeight='bold'
                    textTransform='uppercase'>
                    {label}
                </StatLabel>
                <Flex direction="column" alignItems="flex-start">
                    {isLoading ?
                        <Spinner color='blue.500' /> :
                        <>
                            <Box
                                component="span"
                                sx={(theme) => ({
                                    backgroundColor: '#3182ce',
                                    borderRadius: '0.25rem',
                                    color: '#fff',
                                    p: '0.25rem',
                                    display: 'inline-block',
                    width: 'fit-content', // Usa fit-content para ajustarse exactamente al contenido
                    maxWidth: '100%'
                                })}
                            >
                                <StatNumber fontSize='sm' color={textColor}>{isMoney ? moneyFormat(result) : result}</StatNumber>
                            </Box>
                            {displayText && (
                                <Text 
                                    fontSize='xs' 
                                    color='gray.500' 
                                    mt='2px'
                                    fontStyle='italic'
                                >
                                    {displayText}
                                </Text>
                            )}
                        </>
                    }
                </Flex>
            </Stat>
        }
    </Flex>
}

export default DataLabel;